import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

export const getCampaignsDeliverabilityReport = async campaignId => {
  const query = `
      query ($campaignId:ID!) {
        campaign(id:$campaignId) {
          deliverabilityReport {
            id
            nodes {
                zipCode
                totalMailed
                totalMailedPercent
                totalEstimated
                totalEstimatedPercent
                resultsByDate {
                  nodes {
                    date
                    amount
                  }
                }
              }
            }
          }
        }
    `

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/StatsDeliverability/gql.js